import { Box, Button, Tooltip, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { flexMixin } from 'utils/flexMixin';

import { NamespacesList } from 'core/enums/common';

import { ReactComponent as Refresh } from 'assets/icons/refresh.svg';
import { regularTextColor } from 'assets/styles/_palette';

interface ListElementProps {
	index: number;
	countOfElements: number;
	onClick: () => void;
	children: ReactNode;
	isDeleted: boolean;
}

export const ListElement: FC<ListElementProps> = ({
	index,
	countOfElements,
	onClick,
	children,
	isDeleted,
}) => {
	const { t: commonTranslate } = useTranslation(NamespacesList['common']);

	return (
		<Box sx={{ ...flexMixin({ gap: 5 }) }}>
			<Typography sx={{ color: regularTextColor }}>{index + 1}.</Typography>
			{children}
			<Tooltip
				className="not-rtl-able"
				componentsProps={{
					tooltip: {
						sx: {
							backgroundColor: '#f5f5f9',
							color: 'rgba(0, 0, 0, 0.87)',
							fontSize: '12px',
							maxWidth: 200,
							textAlign: 'center',
							marginBottom: '5px',
							border: '1px solid #dadde9',
							'& .MuiTooltip-popper': { margin: 0 },
						},
					},
					popper: {
						sx: {
							marginBottom: '5px',
						},
					},
				}}
				PopperProps={{
					modifiers: [
						{
							name: 'offset',
							options: {
								offset: [0, 0],
							},
						},
					],
				}}
				title={countOfElements === 0 ? commonTranslate('tooltips.atLeastOneExcitingElement') : null}
				placement="left"
			>
				<Box>
					<Button
						type="button"
						sx={{
							minWidth: '24px',
							height: '24px',
							fontSize: '24px',
							color: '#9FA6B3',
						}}
						onClick={onClick}
						disabled={countOfElements === 0}
					>
						{isDeleted ? <Refresh /> : <span>&times;</span>}
					</Button>
				</Box>
			</Tooltip>
		</Box>
	);
};
